import { CustomForm } from 'App/Components/CustomForm'
import React from 'react'

export const CustomFormPage = () => {
  return <CustomForm />
}
